export default __webpack_public_path__ + "sounds/correct2.mp3";